export enum CommentReaction {
    None = 0,
    Nostalgia = 1,
    Like = 2,
}
